export default [
  {
    path: '/scales',
    name: 'scales',
    component: () => import('./ScaleList.vue'),
    meta: {
      name: 'Escalas',
      auth: true,
      user: 'Admin',
    },
  },
]
